var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H34C35.1 20 36 20.9 36 22V34C36 35.1 35.1 36 34 36H18C16.9 36 16 35.1 16 34V22C16 20.9 16.9 20 18 20Z",
    stroke: "#FFC670",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22L26 29L16 22",
    stroke: "#FFC670",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3737 9.86628C27.5825 6.4161 48 5.06363 48 27.2552C48 45.0581 30.799 50.3025 19.4714 47.1284C8.14392 43.9542 -3.90105 30.791 5.20715 16.4908C14.437 1.99958 31.3137 2 29.1208 2",
    stroke: "#FFC670",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicon);
export default __webpack_public_path__ + "static/media/Infoicon.db6e8bf7ca5e874d31c8533a6d5a541d.svg";
export { ForwardRef as ReactComponent };